(() => {
  const SELECTOR = '.header__inline-menu details.mega-menu';
  const closeTimers = new WeakMap();

  const cancelClose = (menu) => {
    const timer = closeTimers.get(menu);
    if (timer) window.clearTimeout(timer);
    closeTimers.delete(menu);
  };

  const positionBridge = (menu) => {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    const bridge = menu.querySelector('.mega-menu__hover-bridge');
    if (!summary || !content || !bridge) return;

    const summaryRect = summary.getBoundingClientRect();
    const offsetParent = content.offsetParent;
    const contentTop = offsetParent
      ? offsetParent.getBoundingClientRect().top + content.offsetTop
      : content.getBoundingClientRect().top;
    const gap = Math.max(0, contentTop - summaryRect.bottom);

    // Keep the panel below the entire navigation so wrapped second-row links
    // remain usable. A narrow transparent bridge connects only this trigger to
    // the panel, preserving hover while the pointer crosses the wrapped row.
    bridge.style.left = `${summaryRect.left}px`;
    bridge.style.top = `${summaryRect.bottom - 1}px`;
    bridge.style.width = `${summaryRect.width}px`;
    bridge.style.height = `${gap + 2}px`;
    bridge.style.display = gap > 0 ? 'block' : 'none';
  };

  const closeMenu = (menu) => {
    cancelClose(menu);
    const bridge = menu.querySelector('.mega-menu__hover-bridge');
    if (bridge) bridge.style.display = 'none';
    menu.classList.remove('open');
    menu.removeAttribute('open');

    const summary = menu.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  const openMenu = (menu) => {
    cancelClose(menu);
    menu.classList.add('open');
    menu.setAttribute('open', '');
    positionBridge(menu);

    const summary = menu.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  };

  const scheduleClose = (menu) => {
    cancelClose(menu);

    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    const gap = summary && content
      ? Math.max(0, content.getBoundingClientRect().top - summary.getBoundingClientRect().bottom)
      : 0;

    // When the navigation wraps, the panel remains aligned to the bottom of
    // the whole header. Keep the menu open long enough for the pointer to cross
    // that extra row, then close normally if the pointer never reaches it.
    const delay = Math.min(700, Math.max(180, gap * 8));
    closeTimers.set(menu, window.setTimeout(() => closeMenu(menu), delay));
  };

  const bindMenu = (menu) => {
    if (menu.dataset.chromeFixBound === 'true') return;
    menu.dataset.chromeFixBound = 'true';

    const bridge = document.createElement('span');
    bridge.className = 'mega-menu__hover-bridge';
    bridge.setAttribute('aria-hidden', 'true');
    Object.assign(bridge.style, {
      position: 'fixed',
      display: 'none',
      pointerEvents: 'auto',
      background: 'transparent',
      zIndex: '99',
    });
    menu.appendChild(bridge);

    closeMenu(menu);

    menu.addEventListener('mouseenter', () => openMenu(menu));
    menu.addEventListener('mouseleave', () => scheduleClose(menu));
    menu.addEventListener('focusin', () => openMenu(menu));
    menu.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!menu.contains(document.activeElement)) closeMenu(menu);
      });
    });

    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    if (content) content.addEventListener('mouseenter', () => openMenu(menu));
    bridge.addEventListener('mouseenter', () => openMenu(menu));

    if (summary) {
      summary.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        event.preventDefault();
      });
    }
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach(bindMenu);
  };

  const repositionOpenMenus = () => {
    document.querySelectorAll(`${SELECTOR}.open`).forEach(positionBridge);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', init);
  window.addEventListener('resize', repositionOpenMenus, { passive: true });
})();
